import { useMemo } from "react";
import { BaseballTable } from "../tables/BaseballTable";
import { getBattingColumns } from "../../config/battingColumns";
import { getPitchingColumns } from "../../config/pitchingColumns";
import {
  columnsBaserunningPlayer,
  columnsBattedBallBatter,
  columnsBattedBallPitcher,
  columnsSituationalBatter,
  columnsSituationalPitcher,
  columnsSplitsBatter,
  columnsSplitsPitcher,
  columnsValuePitcher,
} from "../../config/leaderboards";

const stripRank = (cols) => cols.filter((c) => c.name !== "#");
const unlink = (cols) => cols.map((c) => {
  if (c.name === "Player") {
    return { ...c, cell: undefined };
  }
  return c;
});

const COLUMN_MAP = {
  batting: () => getBattingColumns(true),
  pitching: () => getPitchingColumns(true),
  baserunning: () => unlink(stripRank(columnsBaserunningPlayer)),
  batted_ball: () => unlink(stripRank(columnsBattedBallBatter)),
  batted_ball_pitcher: () => unlink(stripRank(columnsBattedBallPitcher)),
  situational: () => unlink(stripRank(columnsSituationalBatter)),
  situational_pitcher: () => unlink(stripRank(columnsSituationalPitcher)),
  splits: () => unlink(stripRank(columnsSplitsBatter)),
  splits_pitcher: () => unlink(stripRank(columnsSplitsPitcher)),
  value_pitcher: () => unlink(stripRank(columnsValuePitcher)),
};

const StatTable = ({ stats, type }) => {
  const columns = useMemo(() => {
    const getColumns = COLUMN_MAP[type];
    return getColumns ? getColumns() : [];
  }, [type]);

  return (
    <BaseballTable
      data={stats}
      columns={columns}
      filename={`player_${type}_stats.csv`}
    />
  );
};

export default StatTable;
